<template>
    <div class="GlitchEffectWrapper">
      
        <div class="sliderWrapper">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    OFFSET
                </label>
                <div class="flex-1">
                    <input type="range" @input="setOffset" :value="offset" min="1" max="100" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{offset}}</div>
            </div>
        </div>
        <div class="sliderWrapper mt-2">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    DIRECTION
                </label>
                <div class="flex-1">
                    <input type="range" @input="setDirection" :value="direction" min="-180" max="180" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{direction}}</div>
            </div>
        </div>
       
       
        <div class="colorWrapper mt-2">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    COLOR
                </label>
              <div class="d-flex">
                <div class="glitchColors mr-2" @click="setColor('rgb(255, 0, 255)')">
                    <div class="flex-1" style="background-color: rgb(0, 255, 255);"></div>
                    <div class="flex-1" style="background-color: rgb(255, 0, 255);"></div>
                </div>
                <div class="glitchColors" @click="setColor('rgb(255, 0, 0)')">
                    <div class="flex-1" style="background-color: rgb(0, 255, 255);"></div>
                    <div class="flex-1" style="background-color: rgb(255, 0, 0);"></div>
                </div>
              </div>
            </div> 
        </div>

    </div>
</template>

<script>

export default {
    name:"GlitchEffect",
    data(){
        return{
            color:"",
            offset:"30",
            direction:"90",
        }
    },
    computed:{
        getObjProperties(){
            return this.$store.getters.getActiveObjectprops
        },
       
    },
    watch:{
        getObjProperties :{
          handler(updatedValues) {
            
            this.color = updatedValues.effectType.color;
            this.offset = updatedValues.effectType.offset;
            this.direction = updatedValues.effectType.direction;
         
                
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
        setColor(e){
            
            this.color = e;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createGlitch() });
            
        },
        setOffset(e){
            
            this.offset = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createGlitch() });

        },
        setDirection(e){
            
            this.direction = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createGlitch() });

        },
        createGlitch(){
              
            let obj = {
              type:"glitch",
              color:this.color,
              offset:this.offset,
              direction:this.direction,
            };
  
              return obj
        }
    
    }
}
</script>
<style scoped>
.colorWrapper{
    padding: 0 19px;
}
.glitchColors {
    border-width: 2px;
    border-radius: .25rem;
    overflow: hidden;
    cursor: pointer;
    width: 2.5rem;
    height: 1.75rem;
    display: flex;

}
.glitchColors .flex-1 {
    flex: 1 1;


}
</style>